var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"video-container",style:({ width: _vm.size })},[_c('div',{staticClass:"widescreen"},[_c('div',{staticClass:"video"},[_c('iframe',{ref:"video",staticClass:"content-video",attrs:{"src":_vm.link,"frameborder":"0","sandbox":"allow-same-origin allow-scripts","allowfullscreen":"allowfullscreen"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }